import { render, staticRenderFns } from "./approvalNotification.vue?vue&type=template&id=dc98912c&"
import script from "./approvalNotification.vue?vue&type=script&lang=js&"
export * from "./approvalNotification.vue?vue&type=script&lang=js&"
import style0 from "./approvalNotification.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports